import Vuex from "vuex";
import { shallowMount } from "@vue/test-utils";
import CityList from "@/components/core/composite/combos/CityList";
import Vue from "vue";

Vue.use(Vuex);

describe("CityList component", () => {
  let wrapper;

  beforeEach(() => {
    const store = new Vuex.Store({
      state: {
        localidadesAgregadas: []
      }
    });

    const propsData = {
      localidades: []
    };
    wrapper = shallowMount(CityList, { store, propsData });
  });

  it("Renders del component CityList", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
